const contribute = [{"key":"contribute.greeting","string":"Pozdravljeni {variable}, tu je pregled vaših vsebin."},{"key":"contribute.logout","string":"Izpis"}]

export default contribute



// WEBPACK FOOTER //
// ./src/i18n/sl/contribute/_contribute.js